import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";

/**
 * Generated class for the TextareaInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "fixed-label-textarea-input",
  templateUrl: "fixed-label-textarea-input.component.html",
})
export class FixedLabelTextAreaInputComponent implements OnInit, AfterViewInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  placeholder: string = "placeholder";
  rows: number = 5;
  maxLength: number = 1000; //default
  minLength: number;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;
  showCharCounter: boolean = false;
  preventExceedMaxLength: boolean = false;
  spaceBetween: boolean = true;
  display: string = "contents";

  constructor(public formBuilder: FormBuilder) {
    // console.log('Hello TextareaInputComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Group: ", this.group );
    // console.log( "TextArea input config: ", this.config );

    let config = this.config;

    this.id = config.id;
    this.componentId = this.config.componentId;
    this.label = config.label !== undefined ? config.label : config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = config.readonly;
    if (config.placeholder) {
      this.placeholder = config.placeholder;
    }
    if (config.rules && config.rules.spaceBetween == false) {
      this.spaceBetween = false;
    }
    if (config.rules && config.rules.display) {
      this.display = config.rules.display;
    }

    this.group.addControl(this.id, this.formBuilder.control(undefined));
    this.disabled = this.group.controls[this.id].disabled;
    let selfControl = this.group.controls[this.id];

    this.setRules(config, selfControl);

    selfControl.valueChanges.subscribe((data) => {
      if (this.disabled !== selfControl.disabled) {
        this.disabled = selfControl.disabled;
      }
    });
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.setRules(this.config, this.group.controls[this.id]);
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  setRules(config, selfControl) {
    var validators = [];
    if (config.rules) {
      if (config.rules.rows) {
        this.rows = config.rules.rows;
      }

      if (config.rules.required) {
        this.required = config.rules.required;
        validators.push(Validators.required);
      }

      if (config.rules.minLength) {
        this.minLength = config.rules.minLength;
        validators.push(Validators.minLength(this.minLength));
      }

      if (config.rules.maxLength) {
        this.maxLength = config.rules.maxLength;
        validators.push(Validators.maxLength(this.maxLength));
      }

      if (config.rules.showCharCounter) {
        this.showCharCounter = config.rules.showCharCounter;
      }

      if (config.rules.preventExceedMaxLength) {
        this.preventExceedMaxLength = config.rules.preventExceedMaxLength;
        this.group.controls[this.id].valueChanges.subscribe((data) => {
          if (
            this.preventExceedMaxLength &&
            data &&
            data.length > this.maxLength
          ) {
            this.group.controls[this.id].setValue(
              data.substring(0, this.maxLength)
            );
          }
        });
      }
    } else {
      this.required = false;
      this.minLength = 0;
      this.maxLength = 1000;
      selfControl.clearValidators();
    }

    var composedValidators: ValidatorFn = Validators.compose(validators);

    selfControl.setValidators(composedValidators);
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (
      this.required &&
      (undefined === this.getCurrentValue() ||
        null === this.getCurrentValue() ||
        "" === this.getCurrentValue())
    ) {
      errors["required"] = true;
    }
    if (null !== this.getCurrentValue() && "" !== this.getCurrentValue()) {
      if (this.getCurrentValue().length < this.minLength) {
        errors["minlength"] = true;
      }

      if (this.getCurrentValue().length > this.maxLength) {
        errors["maxlength"] = true;
      }
    }

    return Object.keys(errors).length == 0 ? undefined : errors;
  }

  getCurrentValue(): string {
    let textareaValue = this.group.controls[this.id].value;
    return textareaValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/fixed-label-textarea-input/fixed-label-textarea-input.component.ts